import React from 'react';

import { buildClassNames } from '../../utils';

import './index.scss';

export const TextInput: React.FC<React.ComponentProps<'input'>> = ({ className, ...props }) => {
  const classNames = buildClassNames('chron__text-input', className);
  return <input className={classNames} type="text" {...props} />;
};
